module.exports = __webpack_public_path__ + "static/img/knowledge.ac4f40c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/knowledge.png
// module id = lDb6
// module chunks = 1